import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import React from 'react'

import content from '../../../../prismic-translates/dialog-sc-request-code.json'
import classes from '../styles.module.scss'

import Scratch from './Scratch'

const t = getTranslationFromJson([content])

type Props = {
  onScratchComplete: () => void
}

export default function ScratchCardStep({ onScratchComplete }: Props) {
  return (
    <div className={classes.scratchCardContainer}>
      <p className='mt-typography-body1'>{t('scratch_here')}</p>
      <Scratch onComplete={onScratchComplete}>
        <div className={classes.scratchContainer}>
          <h5 className={`mt-typography-h5 ${classes.scratchingText}`}>{t('continue_scratching')}</h5>
        </div>
      </Scratch>
    </div>
  )
}
